import {Injectable} from '@angular/core';

@Injectable()
export class CurrencyDetails {
    CurrencySymbol: string;
    CurrencyCode: number;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/Utilities/Currencydetails.ts